<template>
    <div class=" mt-1 rounded border">
        <vue-apex-charts
            v-if="series"
            ref="chart"
            type="area"
            height="200"
            :options="options.chartOptions"
            :series="series"
        />
    </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'
import { $themeColors } from '@themeConfig'
import System from '@/utilities/system'

export default {
    components:{
        VueApexCharts
    },
    props:{
        datas:{
            type:Array,
            default:()=>[]
        }
    },
    data(){
        return{
        }
    },
    methods:{
        converter(int){
            return int
        }
    },
    mounted(){
        this.$refs.chart?.refresh()
    },
    computed:{
        series(){
            if(this.datas?.length){
                if(this.gStatus){
                    return [
                        {
                            data: this.datas.map(d=>d.NetSalary).reverse(),
                            name:"Maaş"
                        },
                        {
                            data: this.datas.map(d=>d.SGKSalary).reverse(),
                            name:"SGK"
                        },
                    ]
                }else return [
                    {
                        data: this.datas.map(d=>d.SGKSalary).reverse(),
                        name:"Maaş"
                    },
                ]
            }else return []
        },
        options(){
            return {
                chartOptions: {
                    chart: {
                        zoom: {
                            enabled: false,
                        },
                        toolbar: {
                            show: false,
                        },
                    },
                    colors: [$themeColors.primary,$themeColors.success],
                    dataLabels: {
                        enabled: false,
                    },
                    tooltip:{
                        y:{
                            formatter(s){
                                return [parseFloat(s).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').replace(/.([^.]*)$/, ",$1"),"TL"].join(' ')
                            }
                        }
                    },
                    stroke: {
                        width:2,
                        curve: 'straight',
                    },
                    grid: {
                        xaxis: {
                            lines: {
                                show: true,
                            },
                        },
                    },
                    xaxis: {
                        categories: this.datas.map(d=>d.NetDate),
                    },
                    yaxis: {
                        labels: {
                            formatter: function (value) {
                                return  [parseFloat(value).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, '$1.').replace(/.([^.]*)$/, ",$1"),"TL"].join(' ')
                            }
                        },
                    },
                },
            }
        },
        gStatus(){
            return System.GStatus
        },  
    }
}
</script>

<style>

</style>